import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const ModalContent = styled.div`
  padding: 50px 30px 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 400px;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 20px;
  font-weight: 500;
  margin: 0 auto;
`;

export const OuterCircle = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #c8e6c9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
`;

export const InnerCircle = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #4caf50;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('/images/business/result.svg');
  background-repeat: no-repeat;
  background-position: center;
`;

export const ModalCloseButton = styled(Typography.Text)`
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.brand.main};
  padding: 15px 35px;
  color: ${({ theme }) => theme.palette.system.white};
  text-align: center;
  width: 100%;
  cursor: pointer;
`;

export const ModalDescription = styled.div`
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  margin: 15px 0 30px;
`;
